import {Component, HostListener, Input, OnInit} from '@angular/core';
import {ImagePreviewService} from "../../../service/image-preview.service";

@Component({
    selector: 'app-image-preview',
    templateUrl: './image-preview.component.html',
    standalone: false
})
export class ImagePreviewComponent implements OnInit {

  @Input('isVisible') isVisisble: boolean

  @Input('images') images: string[]

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(_event: Event) {
    this.hideModal()
  }

  previewLoadFailed = false

  hideModal() {
    this.images = []
    this.isVisisble = false
    this.previewLoadFailed = false
  }

  constructor(private imagePreviewService: ImagePreviewService) {
  }

  ngOnInit(): void {
    this.imagePreviewService._imageSource.asObservable().subscribe({
      next: data => {
        this.images = []
        this.previewLoadFailed = false

        if (data != null) {
          this.images.push(data)
          this.isVisisble = true
        } else {
          this.isVisisble = false
        }

      },
    })
  }

}
